import { M365PulseInfoRow } from "./M365PulseInfoRow";
import { M365PulseInfoRowsProps } from "./M365PulseInfoRows.types";
import React from "react";
import { SpinnerType } from "Enumerations";
import { mergeClasses } from "@fluentui/react-components";
import { observer } from "mobx-react";
import { useM365PulseInfoRowsStyles } from "./M365PulseInfoRows.styles";
import { withStatus } from "..";

const M365PulseInfoRowsBase = (props: M365PulseInfoRowsProps) => {
    const { items, className, ...restProps } = props;
    const classNames = useM365PulseInfoRowsStyles();
    const rootClassName = mergeClasses(classNames.root, className);

    return (
        <div className={rootClassName}>
            {items.map((item) => (
                <M365PulseInfoRow key={item.fieldName} {...restProps} {...item} />
            ))}
        </div>
    );
};

export const M365PulseInfoRows = withStatus(observer(M365PulseInfoRowsBase), SpinnerType.Skeleton);
M365PulseInfoRows.displayName = "M365PulseInfoRows";
